<template>
  <v-container class="page-content px-5" style="  width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        dense
        flat
    >
      <v-spacer></v-spacer>
      <v-btn
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          class="mr-0 dark-primary"
          @click="newGuardPost"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp">
        <v-btn
           text
            @click="newGuardPost"
            class="rounded-tr-lg dark-primary"
        >
          Добавить пост охраны
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-1 rounded-b-lg"
    >
      <template v-slot:item.name="props">
        <span style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">{{props.item.name}}</span>
      </template>
      <template v-slot:item.territory="{ item }">
        <span>{{ item.territory.name }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="mr-2"
                @click="editGuardPost(item)"
                v-bind="attrs"
                v-on="on"
            >
              edit
            </v-icon>
          </template>
          <span>Редактировать</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                @click="deleteGuardPost(item)"
                v-bind="attrs"
                v-on="on"
            >
              delete
            </v-icon>
          </template>
          <span>Удалить</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="loadData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :guard-post-data="guard_posts_data"
        @close="closeEditDialog"
    ></EditDialog>
    <ApplyDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить организацию ?`"
        @close="closeDeleteDialog"
    ></ApplyDialog>
  </v-container>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import EditDialog from "../components/GuardPostsEditDialog";
import ApplyDialog from "@/modules/core/components/ApplyDialog";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";
import names from "@/modules/admin/routers/names";

export default {
  name: "AdminGuardPostsList",
  components: {EditDialog, ApplyDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список постов охраны",
      dialog_add_edit: false,
      dialog_delete: false,
      edit_status: undefined,
      guard_posts_data: undefined,
      headers: [
        {text: "Наименование", value: "name", align: "start", sortable: false, width: "30%"},
        {text: "Территория", value: "territory", align: "start", sortable: false, width: "30%"},
        {text: "Пароль", value: "password", align: "start", sortable: false, width: "20%"},
        {text: "Действия", value: "actions", sortable: false, align: "center", width: "20%"}
      ]
    }
  },
  computed: {
    ...mapGetters({
      items: "admin/getGuardPost",
      count: "admin/getGuardPostCount",
      isLoading: "admin/isLoadingGuardPost",
      getCurrentUrl: "admin/getGuardPostCurrentUrl"
    })
  },
  watch: {},
  methods: {
    ...mapActions({
      loadGuardPostsList: "admin/loadGuardPostList",
      deleteGuardPosts: "admin/deleteGuardPost"
    }),
    getDetail(item) {
      this.$router.push({name: names.GUARD_POSTS.DETAIL, params: {idGuardPost: item.id}}).catch(() => {})
    },
    loadData(url = undefined) {
      this.loadGuardPostsList({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    newGuardPost() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.guard_posts_data = undefined
    },
    editGuardPost(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.guard_posts_data = item
    },
    deleteGuardPost(item) {
      this.dialog_delete = true
      this.guard_posts_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.guard_posts_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteGuardPosts({
          id: this.guard_posts_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.guard_posts_data = undefined
    }
  },
  created() {
    if (admin.ADMIN.ALLOWED()){
      if (this.getCurrentUrl) {
        this.loadFromSavedUrl(this.getCurrentUrl)
      } else {
        this.loadData()
      }
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
